<template>
    <div>
        <div id="wangeditor">
            <div ref="editorElem" style="text-align:left; position: relative"></div>
        </div>

		<el-dialog title="从图库选择" :visible.sync="fileDialog" append-to-body>
            <!-- <FileList v-if="fileDialog" @success="fileSuccess"></FileList> -->
            <Upload :type="2" @success="imageSuccess"></Upload>
		</el-dialog>
    </div>
</template>
<script>
    import E from "wangeditor";
    import FileList from './FileList.vue'
    export default {
        name: "Editor",
        data() {
            return {
                fileDialog: false,
                editor: null,
                editorContent: ''
            };
        },
        components: {
            FileList
        },
        // catchData是一个类似回调函数，来自父组件，当然也可以自己写一个函数，主要是用来获取富文本编辑器中的html内容用来传递给服务端
        props: ['catchData', 'content'], // 接收父组件的方法
        mounted() {
            this.editor = new E(this.$refs.editorElem);
            // 编辑器的事件，每次改变会获取其html内容
            this.editor.config.onchange = html => {
                this.editorContent = html;
                this.catchData(this.editorContent); // 把这个html通过catchData的方法传入父组件
            };
            this.editor.config.uploadImgServer = this.$config.baseUrl + '/api/admin/file/upload/editor';
            this.editor.config.uploadImgParams = {
                // 如果版本 <=v3.1.0 ，属性值会自动进行 encode ，此处无需 encode
                // 如果版本 >=v3.1.1 ，属性值不会自动 encode ，如有需要自己手动 encode
                type: 'editor'
            }
            this.editor.config.showLinkImg = false;
            this.editor.config.excludeMenus = [
                'video',
            ],
            this.editor.config.uploadImgHeaders = {
                'Authorization': this.$util.cacheGet("authToken")
            };
            this.editor.config.uploadFileName = 'file'

            this.editor.config.uploadImgFromMedia = () => {
                this.fileDialog = true;
                // 做调起媒体库UI等的自定义方法
                // 举个栗子，假设通过confirm方法来模拟调用媒体库
                // const img = confirm('调用媒体库')
                // if (img) {
                //     const imgUrl = 'https://www.baidu.com/img/PCtm_d9c8750bed0b3c7d089fa7d55720d6cf.png'
                //     // 通过editor.cmd.do方法将媒体库回调的链接插入编辑器内
                //     this.editor.cmd.do(
                //     'insertHTML',
                //     `<img src="${imgUrl}" style="max-width:100%;"/>`
                //     )
                // } else {
                //     console.log('cancel')
                // }
            }
            this.editor.create();
            if(this.content){
                this.editor.txt.html(this.content)
            }
        },
        methods: {
            fileSuccess(e){
                const imgUrl = this.$util.img(e.url);
                this.editor.cmd.do(
                    'insertHTML',
                    `<img src="${imgUrl}" style="max-width:100%;"/>`
                )
                this.$message({
                    message: '已插入图片'
                })
                // this.fileDialog = false;
            },
            imageSuccess(res){
                this.fileDialog = false
                const imgUrl = this.$util.img(res.url);
                this.editor.cmd.do(
                    'insertHTML',
                    `<img src="${imgUrl}" style="max-width:100%;"/>`
                )
                this.$message({
                    message: '已插入图片'
                })
            }
        }
    }
</script>
<style>
    .w-e-toolbar{
        z-index: 31!important;
    }
    .w-e-text-container{
        z-index: 30!important;;
    }
</style>


// WEBPACK FOOTER //
// src/components/Editor.vue